export default function PreviewButton(props) {
  return (
    <button className="px-5 py-3 bg-indigo-700 bg-opacity-10 rounded-3xl shadow border border-zinc-300 justify-start items-center gap-2 inline-flex">
      <span className="Plumbing text-indigo-700 text-sm md:text-base font-normal">
        {props.text}
      </span>
    </button>
  );
}